
import { useSelector } from 'react-redux'
import styles from './actionButtonGroups.styles.module.scss'
import { IActionButtonGroupsProps } from './type'
import { RootState } from 'store/store'

const ActionButtonGroups = (props: IActionButtonGroupsProps) => {
    const { miniSidebar } = useSelector((rootState: RootState) => rootState.DashboardUIReducer)
    const { children } = props
    
    return (
        <div className={`${styles.btnGroup} ${miniSidebar ? styles.isFullSizeWidth : styles.isMiniWidth}`}>
            {children}
        </div>
    )
}
export default ActionButtonGroups